import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.005 9c-.425 0-.855-.11-1.19-.325L1.805 6.71A1.96 1.96 0 0 1 .91 5.06c0-.67.335-1.285.895-1.65L4.82 1.45c.67-.435 1.715-.435 2.38.005l2.995 1.965a1.967 1.967 0 0 1 0 3.29L7.2 8.675c-.335.22-.765.325-1.195.325m0-7.125c-.285 0-.57.065-.775.205L2.22 4.04c-.35.23-.555.6-.555 1.02s.2.79.555 1.02l3.01 1.965c.415.27 1.145.27 1.56 0L9.785 6.08c.35-.23.55-.6.55-1.02s-.2-.79-.55-1.02L6.79 2.075c-.21-.13-.495-.2-.785-.2" }, null, -1),
    _createElementVNode("path", { d: "M6 11.875c-.22 0-.445-.03-.625-.09l-1.595-.53c-.755-.25-1.35-1.075-1.345-1.87L2.44 7.04c0-.205.17-.375.375-.375s.375.17.375.375l-.005 2.345c0 .47.39 1.01.835 1.16l1.595.53c.2.065.57.065.77 0l1.595-.53c.445-.15.835-.69.835-1.155V7.07c0-.205.17-.375.375-.375s.375.17.375.375v2.32c0 .795-.59 1.615-1.345 1.87l-1.595.53c-.18.055-.405.085-.625.085" }, null, -1),
    _createElementVNode("path", {
      fill: "#1F747F",
      d: "M10.7 8.375A.38.38 0 0 1 10.325 8V5c0-.205.17-.375.375-.375s.375.17.375.375v3c0 .205-.17.375-.375.375"
    }, null, -1)
  ]))]))
}
export default { render: render }